import React, { useContext } from "react"
import BannerContext from "../lib/context"
import Helmet from "react-helmet"

import Header from '../components/Header'
import { TextSection } from '../components/Section'

import BannerSection from "../components/BannerSection"


// import PastoralImage from '../assets/images/home/pastoral-care3.jpg'
import PastoralImage from '../assets/images/core/PastoralCare2.jpg'
// import Marathon from '../assets/images/stock-photos/london-marathon.jpg'
import Marathon from '../assets/images/church/marathon.jpg'


import PersonPersonImage from '../assets/images/home/person-to-person2.jpg'
import CraftsImage from '../assets/images/general/25.jpg'
import ArnoldHouseImage from '../assets/images/stock-photos/senior-people.jpg'
import Serving from "../assets/images/fujifilm/387.jpg"







export default () => {

    const siteTitle = "Blackheath and Charlton Baptist Church - Serving"
    const pageName = 'serving-banners'
    const pageData = useContext( BannerContext )[pageName]

    // const pageData = useLocalData( getStaticPageData, pageName, pageName )
    const { header, banners } = pageData || { header: null, banners: null }
    const headerImages = header ? header.images : []
    const headerTitle = header ? header.title : 'Serving Our Community'
    
    // const headerImages = useData( getHomeHeader )
    // const headerTitle = "Serving Our Community"
    // const headerIcon = <span className="icon major"><i className="fas fa-seedling"></i></span>

    
    return (
        <div id="serving-page">
            <Helmet title={siteTitle} />
            <Header images={[ Serving ]} headerTitle={headerTitle} tint={0.3}/>

            {/* <BackgroundSection 
                id="parents-and-tots" 
                title="Parents & TOTS"
                description="TOT, our parents and toddlers’ group, is open to members of our congregation and the community every Tuesday from 9am-11am. All are welcome."
                style="style1"
                background={[ TotsImage ]}
                alt
                blur={0.1}
                tint={0.25}
                
            /> */}

            <TextSection 
                id="pastoral-care" 
                title="Pastoral Care"
                style="style1 large"
                background={[ PastoralImage ]}
                description="Our pastoral care team are available to talk, support, nurture, or walk alongside individuals as required.
  We believe that our love for Jesus Christ should find expression in the way we love and serve members of our congregation and our wider community.
This belief is at the heart of our commitment to serving our community.
You are welcome to contact us if you would like to speak with a member of our team."
                // alt
                tint={0.45}
                alt
                
            />

            <TextSection
                id="person-to-person" 
                style="style2 large padded"
                title="Person to Person"
                background={[ PersonPersonImage ]}
                description={`Our vision is to work alongside the retired and elderly in our community, whether in Shelters, Care Homes, or their own homes.

                Loneliness is a common issue, and we aim to share Bible passages, pray, be a Christ-like presence, and meet people at their point of need -whether physical, emotional, psychological, or practical.

                The well-being of our neighbours in the community will be our focus and underpinned by prayer`
                }
                tint={0.7}
                blur={.2}
                
            />
{/* 
            <HalfBackgroundSection
                id="arnold-house" 
                style="style2"
                title="Arnold House"
                background={[ CafeImage ]}
                description={`Our church family actively engages in fellowship with the elderly residents at Arnold's House, building meaningful relationships and offering support through regular visits and shared moments of community
                `
                }
                tint={.3}     
            /> */}

            <TextSection
                id="thursday-craft" 
                style="style2 large padded"
                title="Thursday Knitting & Craft Group"
                background={[ CraftsImage ]}
                description={`Our group meets every Thursday from 10 am – 12 noon at Corner Stop. Everyone is welcome to join.   
                    You can bring your own needlework, knitting, crochet or other craft.
                    The jumpers, hats and blankets are donated to Christian Hope International and sent to those in need in Eastern Europe.   
                    The muffs, ‘Twiddle Muffs’, are given to dementia patients to keep their hands warm and engaged.`
                }
                opacity={0.1}
                tint={0.25}                
            />

            <TextSection 
                id="arnold-house" 
                title="Arnold House"
                description={`Our church family actively engages in fellowship with the elderly residents at Arnold's House, building meaningful relationships and offering support through regular visits and shared moments of community.`}
                style="style1"
                // buttons={[ { url: "/childrens-church", text: "Read More" } ]}
                background={[ ArnoldHouseImage ]}
                alt
                tint={0.7}
                opacity={0.71}
            />
            
           


            <TextSection
                id="london-marathon" 
                style="style2 large"
                title="London Marathon"
                background={[ Marathon ]}
                description={`Each year, as the London Marathon passes by our church, we welcome spectators with freshly baked cakes and pastries, inviting them to join us for a warm and friendly breakfast. 
                    It's a wonderful opportunity to connect with the community and share in the excitement of the event.`
                }
                blackText={true}
                tint={.1}
                blur={.1}
                opacity={0.2}
                alt               
            />



            {/* <BackgroundSection
                id="homeless-shelter" 
                style="style2"
                title="Homeless Shelter"
                background={[ ShelterImage ]}
                description={`Over the past few years we have been one of the centres for Greenwich Night Shelter. 
                Due to the current pandemic, this has been on hold. 
                However, it is our hope that we will be able to offer this and other key services that are essential to the wellbeing of members of our community in the very near future.`}
                tint={0.2}
            />

            {/* <Section
                id="food-bank" 
                title="Food Bank"
                image={[ FoodBankImage ]}
                description="Greenwich Foodbank distribution takes place in our building every Thursday 11am-1pm. Please contact a member of the team if you have a need or drop by for a chat."
                tint={0.4}
                blur={0.05}
                // roundedImage
                buttons={[{external: true, url: 'https://greenwich.foodbank.org.uk/locations/', text: 'Food bank locations'}]}

            /> */}

            <BannerSection banners={banners} />


        </div>
    )
}
